/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  GRID: {
    DELETE_PDF_FORM_QUESTION: 'Die folgende PDF Vorlage wirklich löschen?',
    SUCCESSFULLY_DELETED_PDF_FORM: 'Die PDF Vorlage wurde erfolgreich gelöscht.',
    ERROR_DELETING_PDF_FORM: 'Beim Löschen der PDF Vorlage ist ein Fehler aufgetreten.',
    ERROR_LOADING_PDF_FORMS: 'Beim Laden der PDF Vorlagen ist ein Fehler aufgetreten.',
    PDF_FORMS: 'PDF Vorlagen',
    SEARCH: 'Suche',
    ID: 'Id',
    NAME: 'Name',
    FILE: 'Datei',
    FORM: 'Formular',
    OPTIONS: 'Optionen',
    CREATED_AT: 'Erstellt am',
    UPDATED_AT: 'Bearbeitet am',
    CHANGE: 'Bearbeiten',
    DELETE: 'Löschen',
    ENTRIES: 'Einträge',
    CREATE: 'Erstellen',
    SIGNATURES: 'Unterschriften'
  },
  CRUD: {
    PDF_FORM: 'PDF Vorlage',
    SAVE: 'Speichern',
    CANCEL: 'Abbrechen',
    NAME: 'Name',
    ENTER_NAME: 'Name eingeben',
    FILE: 'Datei',
    SELECT: 'Auswählen',
    FORM_FIELDS: 'Formularfelder',
    SIGNATURES: 'Unterschriften',
    TITLE: 'Titel',
    ADD: 'Hinzufügen',
    ERROR_SAVING_FORM: 'Beim Speichern der PDF Vorlage ist ein Fehler aufgetreten',
    FOUND_NO_FORM_BY_ID: 'Es wurde keine PDF Vorlage mit folgender Id gefunden:',
    SUCCESSFULLY_SAVED_PDF_FORM: 'Die PDF Vorlage wurde erfolgreich gespeichert',
    SHOW_IN_SGN: 'Immer in SignoSign anzeigen'
  }
};

